class HHeaderDrawer extends HTMLElement {
  constructor() {
    super();
    this._initialized = false;
  }

  connectedCallback() {
    if (this._initialized) return;
    this._initialized = true;

    // ===== Lấy element bên trong chính header-drawer này =====
    this.trigger =
      this.querySelector('.drawer-trigger') ||
      this.querySelector('.header__icon--menu');

    this.drawer = this.querySelector('.drawer');
    this.overlay = this.querySelector('.drawer-overlay');
    this.closeButtons = this.querySelectorAll('.drawer-close, .drawer-overlay');

    // Mobile submenu
    this.mobileToggles = this.querySelectorAll('.submenu-toggle');

    // Desktop submenu
    this.rootItems = this.querySelectorAll('.drawer-col-left .root-item');
    this.submenuPanels = this.querySelectorAll('.drawer-col-right .submenu-panel');

    // Ẩn drawer ban đầu
    if (this.drawer) {
      this.drawer.hidden = true;
    }

    // Hover root item để hiện panel bên phải
    this.rootItems.forEach((item) => {
      item.addEventListener('mouseenter', () => {
        const index = item.dataset.index;
        this._showSubmenu(index);
      });
    });

    // Rời khỏi panel thì ẩn hết submenu (tùy bạn giữ hay bỏ)
    if (this.drawer) {
      this.drawer.addEventListener('mouseleave', () => {
        this.submenuPanels.forEach((panel) => (panel.hidden = true));
      });
    }

    this._bindEvents();
  }

  _bindEvents() {
    // ===== Open =====
    if (this.trigger) {
      this.trigger.addEventListener('click', (e) => {
        e.preventDefault();
        this.open();
      });
    }

    // ===== Close (nút X + overlay) =====
    this.closeButtons.forEach((btn) => {
      btn.addEventListener('click', (e) => {
        e.preventDefault();
        this.close();
      });
    });

    // ===== Mobile submenu toggle =====
    this.mobileToggles.forEach((toggle) => {
      toggle.addEventListener('click', (e) => {
        const btn = e.currentTarget;
        const submenu = btn.nextElementSibling;
        const expanded = btn.getAttribute('aria-expanded') === 'true';
        btn.setAttribute('aria-expanded', String(!expanded));
        if (submenu) submenu.hidden = expanded;
      });
    });

    // ===== ESC để đóng =====
    document.addEventListener('keydown', (e) => {
      if (e.key === 'Escape' && this.isOpen) this.close();
    });

    // ===== Click ra ngoài drawer (desktop) để đóng =====
    document.addEventListener('click', (e) => {
      const isDesktop = window.matchMedia('(min-width: 990px)').matches;
      if (!this.isOpen || !isDesktop) return;

      const clickedInside = this.drawer && this.drawer.contains(e.target);
      const clickedTrigger = this.trigger && this.trigger.contains(e.target);

      if (!clickedInside && !clickedTrigger) {
        this.close();
      }
    });
  }

  get isOpen() {
    return this.classList.contains('open');
  }

  open() {
    if (this.isOpen) return;

    this.classList.add('open');
    if (this.drawer) this.drawer.hidden = false;
    if (this.trigger) this.trigger.setAttribute('aria-expanded', 'true');

    // Cho CSS biết đang mở để xử lý z-index / ẩn m-header
    document.documentElement.classList.add('drawer-open');

    // Chống cuộn nền
    document.body.classList.add('no-scroll');
  }

  close() {
    if (!this.isOpen) return;

    this.classList.remove('open');
    if (this.drawer) this.drawer.hidden = true;
    if (this.trigger) this.trigger.setAttribute('aria-expanded', 'false');

    document.documentElement.classList.remove('drawer-open');
    document.body.classList.remove('no-scroll');

    // Ẩn tất cả panel submenu desktop
    this.submenuPanels.forEach((panel) => (panel.hidden = true));
  }

  _showSubmenu(index) {
    this.submenuPanels.forEach((panel) => {
      panel.hidden = panel.dataset.index !== index;
    });
  }
}

if (!customElements.get('header-drawer')) {
  customElements.define('header-drawer', HHeaderDrawer);
}

// ========== H-HEADER: SHOW ON SCROLL UP ==========
(function () {
  // Đảm bảo chạy sau khi DOM sẵn sàng
  document.addEventListener('DOMContentLoaded', function () {
    // Lấy đúng header vừa gắn data-hhdr
    var headerWrapper = document.querySelector('[data-hhdr="main-header"]');
    if (!headerWrapper) return;

    var lastY    = window.scrollY || window.pageYOffset;
    var threshold = 80;  // < 80px từ top: luôn hiện header
    var deltaMin  = 5;   // tránh nhạy với rung nhẹ
    var ticking   = false;

    function handleScroll() {
      var currentY = window.scrollY || window.pageYOffset;
      var diff = currentY - lastY;

      // Ở gần đầu trang: luôn hiện
      if (currentY <= threshold) {
        headerWrapper.classList.remove('hhdr--hidden');
      } else {
        if (diff > deltaMin) {
          // Đang cuộn xuống: ẩn
          headerWrapper.classList.add('hhdr--hidden');
        } else if (diff < -deltaMin) {
          // Đang cuộn lên: hiện
          headerWrapper.classList.remove('hhdr--hidden');
        }
      }

      lastY = currentY;
      ticking = false;
    }

    window.addEventListener(
      'scroll',
      function () {
        if (!ticking) {
          window.requestAnimationFrame(handleScroll);
          ticking = true;
        }
      },
      { passive: true }
    );
  });
})();
